import type { HistoryTone } from '@/Ship/Components/History'

/**
 * TaskHistoryEvent — словник подій історії завдання (SPEC-006 §5.1 / SPEC-008 §7.2).
 *
 * `HISTORY_EVENT_MAP` дає підпис і тон кожного коду події — це запасний показ
 * для коду, який стрічка не розбирає окремо. Зміну статусу стрічка підписує
 * точніше («Роботу призупинено», «Завдання завершено»), див.
 * `Helpers/taskHistoryEntries`.
 */
export type TaskHistoryEventCode =
    | 'created'
    | 'updated'
    | 'deadline_changed'
    | 'assigned'
    | 'status_changed'
    | 'removed'
    | 'restored'
    | 'comment_added'
    | 'file_attached'

export interface TaskHistoryEventInfo {
    label: string
    tone: HistoryTone
}

export const HISTORY_EVENT_MAP: Record<TaskHistoryEventCode, TaskHistoryEventInfo> = {
    created: { label: 'Завдання створено', tone: 'blue' },
    updated: { label: 'Змінено дані завдання', tone: 'neutral' },
    deadline_changed: { label: 'Змінено дедлайн', tone: 'orange' },
    assigned: { label: 'Призначено виконавців', tone: 'neutral' },
    status_changed: { label: 'Змінено статус', tone: 'purple' },
    removed: { label: 'Завдання видалено', tone: 'red' },
    restored: { label: 'Завдання відновлено', tone: 'green' },
    comment_added: { label: 'Додано коментар', tone: 'neutral' },
    file_attached: { label: 'Прикріплено файл', tone: 'neutral' },
}
